module.exports = __webpack_public_path__ + "img/tent002.c6c25b8f.jpg";